import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/* eslint-disable no-undef */

/* eslint-disable no-console */
import getScript from '../../get-script';

class Paypal {
  constructor(args) {
    this.triggerAnalyticsEventBanners = (page, mktBannerId) => {
      window.ddoEventInit({
        category: {
          primaryCategory: 'button submission'
        },
        eventInfo: {
          eventName: 'flex button',
          eventDescription: `paypal banner - ${page} page - ${mktBannerId.substr(1)}`
        }
      });
    };

    this.triggerAnalyticsEvent = (page, isFinancing) => {
      if (isFinancing) {
        window.ddoEventInit({
          category: {
            primaryCategory: 'button submission'
          },
          eventInfo: {
            eventName: 'flex button',
            eventDescription: `paypal credit - ${page} page`
          }
        });
      } else {
        const pageVar = page === 'checkout' ? 'shipping' : page;
        window.ddoEventInit({
          category: {
            primaryCategory: 'button submission'
          },
          eventInfo: {
            eventName: `blinds paypal ${pageVar}`
          }
        });
      }
    };

    this.watchClickOnMarketingBanners = mktBannerContainerSelector => {
      const $this = this;
      const mktBannersObj = {
        iframeMouseOver: false
      };
      window.addEventListener('blur', () => {
        window.setTimeout(() => {
          if (document.activeElement instanceof HTMLIFrameElement && document.activeElement.closest(mktBannerContainerSelector)) {
            const page = window.digitalData.page.pageInfo.pageType;
            $this.triggerAnalyticsEventBanners(page, mktBannerContainerSelector);
          }
        }, 0);
      });
      document.addEventListener('mouseover', event => {
        if (event.target.matches('[title="paypal_buttons"]')) {
          mktBannersObj.iframeMouseOver = true;
        }
      });
      document.addEventListener('mouseout', event => {
        if (event.target.matches('[title="paypal_buttons"]')) {
          mktBannersObj.iframeMouseOver = false;
        }
      });
    };

    this.paypalLandingPage = '/paypal';
    this.paypal = window.paypal;

    if (args) {
      Object.assign(this, args);
    }

    if (!this.paypalAccountId) {
      console.error('paypalAccountId not provided');
    }

    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector;
    }
  }

  createOrder() {
    var _this = this;

    return _asyncToGenerator(function* () {
      const paypalLegacyReturnCancelUrl = 'https://www.paypal.com/checkoutnow/error';
      const paypalParams = {
        cancelUrl: paypalLegacyReturnCancelUrl,
        returnUrl: paypalLegacyReturnCancelUrl
      };
      return fetch(_this.paypalExpressCheckoutUrl, {
        body: JSON.stringify(paypalParams),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST'
      }).then(res => res.json()).then(data => data.Data.Token);
    })();
  } // eslint-disable-next-line class-methods-use-this


  onApprove(data) {
    const orderID = data.orderID,
          payerID = data.payerID;
    window.location.href = `/Ordering/Checkout/Review?token=${orderID}&PayerID=${payerID}`;
  }

  onClick(data) {
    // TODO: Use new Analytics monorepo library when available
    const page = window.digitalData.page.pageInfo.pageType;
    const pageVar = page === 'checkout' ? 'shipping' : page;
    const fundingSource = data.fundingSource;
    const isPayPalCredit = fundingSource === 'credit' || fundingSource === 'venmo';
    this.triggerAnalyticsEvent(pageVar, isPayPalCredit);
  }

  addHorizontalButtons(container, stylesParam) {
    const $this = this;
    const defaultStyles = {
      color: 'gold',
      fundingicons: false,
      height: 41,
      label: 'paypal',
      layout: 'horizontal',
      shape: 'rect',
      tagline: false
    };

    const style = _extends({}, defaultStyles, stylesParam);

    if (typeof this.paypal !== 'undefined') {
      this.paypal.Buttons({
        createOrder: this.createOrder,
        onApprove: this.onApprove,
        onClick: data => {
          $this.onClick(data);
        },
        style
      }).render(container);
    }
  }

  addVerticalButtons(container) {
    const $this = this;

    if (typeof this.paypal !== 'undefined') {
      this.paypal.Buttons({
        createOrder: this.createOrder,
        onApprove: this.onApprove,
        onClick: data => {
          $this.onClick(data);
        },
        style: {
          color: 'gold',
          fundingicons: false,
          label: 'paypal',
          layout: 'vertical',
          shape: 'rect',
          tagline: false
        }
      }).render(container);
    }
  }

  addMarketingBanner(containerSelector, options) {
    const container = document.querySelector(containerSelector);

    if (container && this.paypalAccountId) {
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }

      this.watchClickOnMarketingBanners(containerSelector);
      const defaultOptions = {
        account: this.paypalAccountId,
        style: {
          layout: 'text',
          logo: {
            type: 'primary',
            position: 'left'
          }
        }
      }; // eslint-disable-next-line no-param-reassign

      options = options || {};
      getScript('https://www.paypalobjects.com/upstream/bizcomponents/js/messaging.js').then(() => {
        const _window = window,
              paypal = _window.paypal;
        paypal.Message.render(_extends({}, defaultOptions, options), containerSelector);
      });
    }
  }

  updateMarketingBanner(containerSelector, options) {
    const container = document.querySelector(containerSelector);

    if (container && this.paypalAccountId) {
      const defaultOptions = {
        account: this.paypalAccountId,
        style: {
          layout: 'text',
          logo: {
            type: 'primary',
            position: 'left'
          }
        }
      };
      getScript('https://www.paypalobjects.com/upstream/bizcomponents/js/messaging.js').then(() => {
        const newOptions = options || {};
        const _window2 = window,
              paypal = _window2.paypal;
        paypal.Message.render(_extends({}, defaultOptions, newOptions), containerSelector);
      });
    }
  }

}

export default Paypal;